import React, { ReactElement, useEffect, useRef, useState, MutableRefObject } from 'react';
import { Drawer } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import LocationCard from './LocationCard';
import { Location, UserLocation } from 'types/common';
import { PlaceType } from '../LocationAutocomplete';
// import LocationAutocomplete, { PlaceType } from '../LocationAutocomplete';

import {
  addItemToLocalStorage,
  getDistance,
  // getItemFromLocalStorage,
  removeItemFromLocalStorage,
} from 'lib/util';

interface LocationDrawerProps {
  openDrawer: boolean;
  toggleDrawer: (close: boolean) => void;
  locations: Location[];
  onBrowseLocation: (location: Location) => void;
}

const DEFAULT_RADIUS = 100;
const LOCATION_PER_SLOT = 5;
const SAVED_LOCATION_KEY = 'finder-saved-location';

const LocationDrawer = ({
  openDrawer,
  toggleDrawer,
  locations,
  onBrowseLocation,
}: LocationDrawerProps): ReactElement => {
  // const [
  //   autocompleteService,
  //   setAutocompleteService,
  // ] = useState<google.maps.places.AutocompleteService | null>(null);
  const [userLocation, setUserLocation] = useState<UserLocation | null>(null);
  const [next, setNext] = useState<number>(LOCATION_PER_SLOT);
  const [foundLocations, setFoundLocations] = useState(locations);

  const geoCoder = useRef() as MutableRefObject<google.maps.Geocoder>;

  /**
   * This callback is triggered when the map and maps api have been successfully loaded.
   * @param param
   */
  // const googleApiLoaded = (): void => {
  //   geoCoder.current = new google.maps.Geocoder();
  //   setAutocompleteService(new google.maps.places.AutocompleteService());
  //   const savedLocation = getItemFromLocalStorage(SAVED_LOCATION_KEY);
  //   if (savedLocation) setUserLocation(JSON.parse(savedLocation));
  // };

  // const onUseMyLocation = (coords: GeolocationCoordinates): void => {
  //   setUserLocation({ map: { lat: coords.latitude, lng: coords.longitude } });
  // };

  useEffect(() => {
    if (userLocation === null) {
      setFoundLocations(locations);
      return;
    }

    const nearby = locations
      .map((loc) => {
        const coords = loc.map;
        const distance = getDistance(
          userLocation.map.lat,
          userLocation.map.lng,
          coords.lat,
          coords.lon
        );
        return { ...loc, currentDistance: distance };
      })
      .filter((loc) => loc.currentDistance <= DEFAULT_RADIUS)
      .sort((a, b) => a.currentDistance - b.currentDistance);

    if (nearby.length) {
      addItemToLocalStorage(SAVED_LOCATION_KEY, JSON.stringify(userLocation));
    }

    setFoundLocations(nearby);
  }, [locations, userLocation]);

  /**
   * Get location from autocomplete and geocode it.
   * @param place
   * @returns
   */
  const locationSelected = (place: PlaceType | null): void => {
    if (place === null) {
      setUserLocation(null);
      removeItemFromLocalStorage(SAVED_LOCATION_KEY);
      return;
    }

    geoCoder.current.geocode({ placeId: place.place_id }, (results) => {
      if (!results) return undefined;
      const result = results[0].geometry.location;
      setUserLocation({ place, map: { lat: result.lat(), lng: result.lng() } });
    });
  };

  return (
    <Drawer
      anchor="right"
      open={openDrawer}
      onBackdropClick={() => toggleDrawer(false)}
      onEscapeKeyDown={() => toggleDrawer(false)}
      onClose={() => toggleDrawer(false)}
      classes={{ paper: 'sm:w-full lg:w-4/12 md:w-8/12' }}
    >
      {/* <div className="h-0">
        <Map
          center={{
            lat: 0,
            lng: 0,
          }}
        />
      </div> */}
      <div className="w-full text-right pr-6 pt-6">
        <button role="menu" aria-label="close navigation menu" onClick={() => toggleDrawer(false)}>
          <Close fontSize="large" />
        </button>
      </div>
      <div className="text-center">
        <h3 className="text-3xl">Select a Location</h3>
        {/* <h3 className="text-2xl mt-4 text-black">Enter city or Zip Code</h3> */}
      </div>
      <div>
        {/* FixMe: Add AutoComplete with FreshPaint */}
        {/* {autocompleteService && (
          <div>
            <LocationAutocomplete
              className="mx-6"
              autocompleteService={autocompleteService}
              onSelect={locationSelected}
              onUseMyLocation={onUseMyLocation}
              initValue={userLocation?.place}
            />
          </div>
        )} */}
        {/* <input className={'border-4 border-highlight-actual rounded-md p-3'} /> */}
      </div>
      <div className="overflow-scroll mx-6 mb-10">
        {foundLocations?.slice(0, next)?.map((location) => (
          <LocationCard
            location={location}
            key={location.sysId}
            onBrowseLocation={onBrowseLocation}
          />
        ))}
        <div className="text-center">
          {next < foundLocations?.length && (
            <button
              className="mt-4  bg-primary text-white p-2 rounded-lg"
              onClick={() => setNext(next + LOCATION_PER_SLOT)}
            >
              Load more
            </button>
          )}
          {foundLocations?.length === 0 && (
            <>
              <h3 className="mt-40 text-lg font-semibold">
                No locations nearby, please try another location or
              </h3>
              <button
                className="mt-2 bg-primary text-white p-1 rounded-lg"
                onClick={() => locationSelected(null)}
              >
                Refresh
              </button>
            </>
          )}
        </div>
      </div>
    </Drawer>
  );
};
export default LocationDrawer;
